import { isEqual } from "lodash";
import { EmptyDoc } from "@bpipartners/plate";

/**
 * Returns true if the input object is equal to the EmptyDoc, false otherwise.
 *
 * @remarks
 * This method is part of the {@link core-library#Statistics | Statistics subsystem}.
 *
 * @param obj - The object to compare
 * @returns bool - True if the input object is equal to the EmptyDoc, false otherwise.
 *
 * @beta
 */
export const plateIsEmpty = (obj) => {
  // temporary fix for empty document as react hook forms adds an id to each field, this is to ensure uniqueness of ids
  // this should be removed when the id issue is resolved in the editor library or if we change keyname of the fields in the form
  Object.entries(obj).forEach(([key, value]) => {
    if (key === "id") return;
    delete obj[key].id;
  });
  return isEqual(obj, EmptyDoc) ? true : false;
};
